function Research2020() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2020</div>
            
            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Feb</div>
                    <div className="w-full">
                        <p><a href="https://nc.math.tsukuba.ac.jp/blogs/blog_entries/view/143/f51bd0fce0f4de1ef9af96707a0dc450?lang=en" target='_blank'>“An extension of homology theory to a sequence of TQFT’s.”</a></p>
                        <p>Tsukuba Workshop for Young Mathematicians 2020, Tsukuba Center of Institutes</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Feb</div>
                    <div className="w-full">
                        <p><a href="https://sites.google.com/view/math-graduate/MATHSCI-FRESHMAN-SEMINAR/2020#h.p_9_wJuBa1L6Sf" target='_blank'>“A sequence of TQFT’s associated with (co)homology theory.”</a></p>
                        <p>Mathsci freshman seminar 2020, Nagoya University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Jan</div>
                    <div className="w-full">
                        <p><a href="" target='_blank'>“Dijkgraaf-Witten theory.”</a></p>
                        <p>Discrete, Algebraic and Geometric Structures I, Tokyo Institute of Technology</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2020;